import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { TelInputDirective } from '../parameters/message-templates/whatsapp-templates/whatsapp-template/whatsapp-template-languages/shared/tel-input/tel-input.directive';
import { angularJSFactoriesProviders } from './angularjs-factories-providers.const';
import { AttachmentThumbnailComponent } from './components/attachment-thumbnail/attachment-thumbnail.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { CardFooterComponent } from './components/card-footer/card-footer.component';
import { KakaotalkTemplatePreviewComponent } from './components/choose-template-flow/shared/kakaotalk-template-preview/kakaotalk-template-preview.component';
import { WhatsappTemplatePreviewComponent } from './components/choose-template-flow/shared/whatsapp-template-preview/whatsapp-template-preview.component';
import { ConditionsOnCustomFieldsComponent } from './components/conditions-on-custom-fields/conditions-on-custom-fields.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DateRangePickerModule } from './components/date-range-picker';
import { DateTimeScheduleModalComponent } from './components/date-time-schedule-modal/date-time-schedule-modal.component';
import { DatetimeIonicPopoverComponent } from './components/datetime-ionic/datetime-ionic-popover/datetime-ionic-popover.component';
import { DatetimeIonicComponent } from './components/datetime-ionic/datetime-ionic.component';
import { EmojiPickerModalComponent } from './components/emojis/emoji-picker-modal.component';
import { EmojisListComponent } from './components/emojis/emojis-list.component';
import { ErrorsPlaceholderCellComponent } from './components/errors-placeholder-cell/errors-placeholder-cell.component';
import { FiltersSidePanelComponent } from './components/filters-side-panel/filters-side-panel.component';
import { HeaderTableFilterComponent } from './components/header-table-filter/header-table-filter.component';
import { KakaotalkTemplateItemComponent } from './components/kakaotalk-template-item/kakaotalk-template-item.component';
import { LinkGroupModalComponent } from './components/link-group-modal/link-group-modal.component';
import { LoaderComponent } from './components/loader/loader.component';
import { MaintenanceModeModalComponent } from './components/maintenance-mode-modal/maintenance-mode-modal.component';
import { MediaModalComponent } from './components/media-modal/media-modal.component';
import { MessageContentComponent } from './components/message-content/message-content.component';
import { MessageEditorWrapperComponent } from './components/message-editor-wrapper/message-editor-wrapper.component';
import { MessageInmessageCarouselComponent } from './components/message-inmessage-carousel/message-inmessage-carousel.component';
import { MessagekakaotalkTemplateComponent } from './components/message-kakaotalk-template/message-kakaotalk-template.component';
import { MessageTextContentComponent } from './components/message-text-content/message-text-content.component';
import { MessageWhatsappTemplateComponent } from './components/message-whatsapp-template/message-whatsapp-template.component';
import { PasswordRequestModule } from './components/password-request/password-request.module';
import { PermissionsPerSiteComponent } from './components/permissions-per-site/permissions-per-site.component';
import { PhoneNumberInputComponent } from './components/phone-number-input/phone-number-input.component';
import { PictureModalComponent } from './components/picture-modal/picture-modal.component';
import { RelativeDateTimeComponent } from './components/relative-date-time/relative-date-time.component';
import { SearchBarComponent } from './components/search-bar/search-bar.component';
import { SelectHierarchicalComponent } from './components/select-hierarchical/select-hierarchical.component';
import { SelectInPopoverComponent } from './components/select-in-popover/select-in-popover.component';
import { SelectIonicPopoverComponent } from './components/select-ionic/select-ionic-popover/select-ionic-popover.component';
import { SelectIonicComponent } from './components/select-ionic/select-ionic.component';
import { SelectModerationActionPopoverComponent } from './components/select-moderation-action-popover/select-moderation-action-popover.component';
import { MoveToPendingOrLeaveInAnsweredComponent } from './components/select-tags/move-to-pending-or-leave-in-answered/move-to-pending-or-leave-in-answered.component';
import { SelectTagPopoverComponent } from './components/select-tags/select-tag-popover/select-tag-popover.component';
import { SelectTagComponent } from './components/select-tags/select-tag/select-tag.component';
import { SelectTagsComponent } from './components/select-tags/select-tags.component';
import { SelectComponent } from './components/select/select.component';
import { AiAssistantSuggestionKnowledgeDocumentsComponent } from './components/single-message-editor/ai-assistant-suggestion-knowledge-documents/ai-assistant-suggestion-knowledge-documents.component';
import { AiAssistantSuggestionComponent } from './components/single-message-editor/ai-assistant-suggestion/ai-assistant-suggestion.component';
import { BZCRichLinkModalComponent } from './components/single-message-editor/bzc-richlink-modal/bzc-richlink-modal.component';
import { CodeMirrorWrapperComponent } from './components/single-message-editor/code-mirror-wrapper/codemirror-wrapper.component';
import { CodemirrorSpellcheckerComponent } from './components/single-message-editor/codemirror-spellchecker/codemirror-spellchecker.component';
import { SpellcheckerLanguageSelectionComponent } from './components/single-message-editor/codemirror-spellchecker/spellchecker-language-selection.component';
import { FavoriteSuggestionComponent } from './components/single-message-editor/favorite-suggestion/favorite-suggestion.component';
import { SingleMessageEditorComponent } from './components/single-message-editor/single-message-editor.component';
import { SiteIconAndNameComponent } from './components/site-icon-and-name/site-icon-and-name.component';
import { TableExpandableListComponent } from './components/table/table-expandable-list/table-expandable-list.component';
import { TableLinkComponent } from './components/table/table-link/table-link.component';
import { TableComponent } from './components/table/table.component';
import { TaskAndMessageActionsMenuComponent } from './components/task-and-message-actions-menu/task-and-message-actions-menu.component';
import { UserPreferencesPasswordChangeComponent } from './components/user-preferences-password-change/user-preferences-password-change.component';
import { VipBulletComponent } from './components/vip-bullet/vip-bullet.component';
import { WhatsappTemplateItemComponent } from './components/whatsapp-template-item/whatsapp-template-item.component';
import { DefaultAvatarCompanyIfErrorDirective } from './directives/default-avatar-company-if-error.directive';
import { DefaultAvatarCustomerIfErrorDirective } from './directives/default-avatar-customer-if-error.directive';
import { JwtSrcDirective } from './directives/jwt-src.directive';
import { MatTooltipShowIfTruncatedDirective } from './directives/mat-tooltip-show-if-truncated.directive';
import { TextareaAutoExpandDirective } from './directives/textarea-auto-expand.directive';
import { ValueAndUnitDirective } from './directives/value-and-unit.directive';
import { MaterialModule } from './material.module';
import { BytesPrefixPipe } from './pipes/bytes-prefix.pipe';
import { DateTimezonePipe } from './pipes/date-timezone.pipe';
import { FileExtensionPipe } from './pipes/file-extension.pipe';
import { TruncateCounterPipe } from './pipes/truncate-counter.pipe';

@NgModule({
  declarations: [
    AiAssistantSuggestionComponent,
    AiAssistantSuggestionKnowledgeDocumentsComponent,
    AttachmentThumbnailComponent,
    AvatarComponent,
    BytesPrefixPipe,
    BZCRichLinkModalComponent,
    CardFooterComponent,
    CodemirrorSpellcheckerComponent,
    CodeMirrorWrapperComponent,
    ConditionsOnCustomFieldsComponent,
    ConfirmDialogComponent,
    DatetimeIonicComponent,
    DatetimeIonicPopoverComponent,
    DateTimeScheduleModalComponent,
    DateTimezonePipe,
    DefaultAvatarCompanyIfErrorDirective,
    DefaultAvatarCustomerIfErrorDirective,
    EmojiPickerModalComponent,
    EmojisListComponent,
    ErrorsPlaceholderCellComponent,
    FavoriteSuggestionComponent,
    FileExtensionPipe,
    FiltersSidePanelComponent,
    HeaderTableFilterComponent,
    JwtSrcDirective,
    KakaotalkTemplatePreviewComponent,
    LinkGroupModalComponent,
    LoaderComponent,
    MaintenanceModeModalComponent,
    MatTooltipShowIfTruncatedDirective,
    MediaModalComponent,
    MessageContentComponent,
    MessageEditorWrapperComponent,
    MessageTextContentComponent,
    MoveToPendingOrLeaveInAnsweredComponent,
    PermissionsPerSiteComponent,
    PhoneNumberInputComponent,
    PictureModalComponent,
    RelativeDateTimeComponent,
    SearchBarComponent,
    SelectComponent,
    SelectHierarchicalComponent,
    SelectInPopoverComponent,
    SelectIonicComponent,
    SelectIonicPopoverComponent,
    SelectModerationActionPopoverComponent,
    SelectTagComponent,
    SelectTagPopoverComponent,
    SelectTagsComponent,
    SingleMessageEditorComponent,
    SiteIconAndNameComponent,
    SpellcheckerLanguageSelectionComponent,
    TableComponent,
    TextareaAutoExpandDirective,
    TruncateCounterPipe,
    UserPreferencesPasswordChangeComponent,
    ValueAndUnitDirective,
    VipBulletComponent,
    ConditionsOnCustomFieldsComponent,
    TelInputDirective,
    KakaotalkTemplateItemComponent,
    WhatsappTemplateItemComponent,
    SearchBarComponent,
    FiltersSidePanelComponent,
    HeaderTableFilterComponent,
    WhatsappTemplatePreviewComponent,
    CardFooterComponent,
    MessageWhatsappTemplateComponent,
    MessagekakaotalkTemplateComponent,
    TaskAndMessageActionsMenuComponent,
    TableLinkComponent,
    TableExpandableListComponent,
    MessageInmessageCarouselComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule.forChild(),
    MaterialModule,
    DateRangePickerModule,
    PasswordRequestModule,
  ],
  exports: [
    AttachmentThumbnailComponent,
    AvatarComponent,
    BytesPrefixPipe,
    BZCRichLinkModalComponent,
    CardFooterComponent,
    CodemirrorSpellcheckerComponent,
    CodeMirrorWrapperComponent,
    ConfirmDialogComponent,
    DatetimeIonicComponent,
    DatetimeIonicPopoverComponent,
    DateTimeScheduleModalComponent,
    DateTimezonePipe,
    DefaultAvatarCompanyIfErrorDirective,
    DefaultAvatarCustomerIfErrorDirective,
    EmojiPickerModalComponent,
    EmojisListComponent,
    ErrorsPlaceholderCellComponent,
    FavoriteSuggestionComponent,
    FileExtensionPipe,
    FormsModule,
    IonicModule,
    JwtSrcDirective,
    KakaotalkTemplatePreviewComponent,
    LinkGroupModalComponent,
    LoaderComponent,
    MaintenanceModeModalComponent,
    MaterialModule,
    MatTooltipShowIfTruncatedDirective,
    MediaModalComponent,
    MessageContentComponent,
    MessageEditorWrapperComponent,
    MessageTextContentComponent,
    MessageWhatsappTemplateComponent,
    MessagekakaotalkTemplateComponent,
    MessageInmessageCarouselComponent,
    MoveToPendingOrLeaveInAnsweredComponent,
    PhoneNumberInputComponent,
    PictureModalComponent,
    ReactiveFormsModule,
    RelativeDateTimeComponent,
    SelectComponent,
    SelectHierarchicalComponent,
    SelectIonicComponent,
    SelectIonicPopoverComponent,
    SelectModerationActionPopoverComponent,
    SelectTagComponent,
    SelectTagPopoverComponent,
    SelectTagsComponent,
    SingleMessageEditorComponent,
    SiteIconAndNameComponent,
    SpellcheckerLanguageSelectionComponent,
    TableComponent,
    TelInputDirective,
    TextareaAutoExpandDirective,
    TranslateModule,
    TruncateCounterPipe,
    UserPreferencesPasswordChangeComponent,
    ValueAndUnitDirective,
    VipBulletComponent,
    KakaotalkTemplateItemComponent,
    WhatsappTemplateItemComponent,
    SearchBarComponent,
    FiltersSidePanelComponent,
    HeaderTableFilterComponent,
    WhatsappTemplatePreviewComponent,
  ],
  providers: [...angularJSFactoriesProviders],
})
export class SharedModule {}
